import React, { Component, useState, useRef } from "react";
import { addDays, differenceInCalendarDays, format } from "date-fns";
import DesktopCalender from "../../../calendar/hotelCalender/theme12/DesktopCalender.js";
import HotelAutoComplete from "./HotelAutoComplete.js";
import cf from "../../../../lib/utils/common.js";
import MobPopupComponent from "../../../ModalPopupComponent/theme12/ModalPopupComponent.js";
import MobileCalender from "../../../calendar/hotelCalender/theme12/MobileCalender.js";
import commonFunction from "../../../../lib/utils/common.js";
import { getRecentSearchHotel } from "../../../../lib/getRecentSearchHotel.js";
import { getStorage, setStorage } from "../../../../lib/utils/localStorage.js";
import Button from "../../../UI/button/index.js";
import { alphanumericSpecialChars, leadingSpaces } from "../../../../lib/utils/regex_cheat_sheet.js";
import PaxComp from "../../../PaxComp/index.js";
import moment from 'moment'
import { th } from "date-fns/locale";

let regions = "";
let indexDropdown = -1;
let search_text = "";
let destination_id = "";
let search_type = "";
export default class Theme12 extends Component {
  constructor(props) {
    super(props);
    this.setScrollDown = React.createRef();
    this.wrapperRef = React.createRef();
    this.advanceSearchWrapper = React.createRef();
    this.guestDetailWrapper = React.createRef();
    this.setScrollCal = React.createRef();

    const defaultCheckIn = cf.getDateWithFormat(new Date(), this?.props?.dateFormat);
    const defaultCheckOut = cf.getDateWithFormat(
      addDays(new Date(), this.props.getDefaultDays ? this.props.getDefaultDays : 2),
      this?.props?.dateFormat
    );

    this.state = {
      hotelName: "",
      showRatingDropdown: false,
      expandHotelNameBoolean: false,
      checkInOutValue: `${defaultCheckIn} - ${defaultCheckOut}`,
      checkInValue: defaultCheckIn,
      checkOutValue: defaultCheckOut,
      dateLimit: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      openRoomDetailList: false,
      expandCheckInOutDateBoolean: false,
      selectedRoomDetails: { rooms: 1, guest: 2 },
      getAutoSuggestList: this.props.getAutoSuggestList,
      isError: {
        hotelName: false,
        checkInOutDate: false,
        roomGuest: false,
        selectedNationality: false,
        selectedGuest: false,
      },
      getDestinationId: "",
      getSearchType: "",
      property_count: "",
      dest_type: {
        code: "",
        name: "",
      },
      roomList: [
        {
          id: 1,
          adults: 2,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: false,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],

      finalRoomList: [
        {
          id: 1,
          adults: 2,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: true,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
      type: "hotel",
      openTraveler: false,
      advSearch: false,
      nationallitySearch: "",
      is_breakfast: "",
      originCountries: [],
      selectedNationality: "",
      response: [],
      isOneStar: false,
      isTwoStar: false,
      isThreeStar: false,
      isFourStar: false,
      isFiveStar: false,
      selectedCheckBoxes: {},
      guest_id: "",
      openSearch: false,
      destination: false,
      calender: false,
      rooms: false,
      selectedDestination: null,
      getrecentSearchList: null,
      getrecentSearchListLocal: null,
      search_key: "hotelSearchKey",
      search_key_all: "hotelSearchKeyAll",
      isKeyDown: false,
      isSearchDest: false,
      btnClicked: false,
      recentSearchClicked: this.props?.state?.recentSearchClicked,
      roomsData: [],
      isRecentSearch: false,
      showRatingDropdown: false,
      selectedRatings: [],
    };
    this.ratingDivRef = React.createRef();
  }





  componentDidMount() {
    // Add global click listener for rating dropdown
    document.addEventListener('click', this.handleGlobalClick);

    // recent serach sec ==>
    if (this.props.isSrp === false) {
      this.props.updateRecentSearch("element");
    }
    let LocalSearch = getStorage(this.state.search_key);

    let LocalSearchAll = getStorage(this.state.search_key_all);

    if (LocalSearchAll != null) {
      this.setState({ getrecentSearchListLocal: JSON.parse(LocalSearchAll) });
    }
    if (LocalSearch != null && LocalSearchAll == null) {
      this.setState({ getrecentSearchListLocal: [JSON.parse(LocalSearch)] });
    }


    if (this.props?.recentSearchData && this.props?.recentSearchData.length > 0) {
      this.props.recentSearchData.map((element, index) => {


        if (index == 0) {

          let formattedDate = moment(element?.checkin, "DD-MM-YYYY").format("DD-MMM-YYYY");

          this.setState({
            hotelName: element.search_text,
            getDestinationId: element.destination_id,
            getSearchType: element.search_type,
            property_count: element.property_count,
            dest_type: {
              code: element.dest_type?.code,
              text: element.dest_type?.text,
            },
            checkInOutValue: cf.getDateWithFormat(new Date(formattedDate), this?.props?.dateFormat) + " - " +
              cf.getDateWithFormat(addDays(new Date(formattedDate),
                this.props.getDefaultDays ? this.props.getDefaultDays : 2
              ), this?.props?.dateFormat),
            checkInValue: cf.getDateWithFormat(new Date(formattedDate), this?.props?.dateFormat),
            checkOutValue: cf.getDateWithFormat(
              addDays(
                new Date(formattedDate),
                this.props.getDefaultDays ? this.props.getDefaultDays : 2
              ),
              this?.props?.dateFormat
            ),
            selectedRoomDetails: element?.selectedRoomDetails,
            roomsData: element?.roomList,
            isRecentSearch: true,
          });
        }
      });
    }


    regions = new URLSearchParams(window.location.search).get("region");
    if (
      !cf.isValueEmpty(this.props) &&
      (this.props.isSRP === true || this.props.isDetail === true) &&
      !cf.isValueEmpty(this.props.query)
    ) {
      let checkInArr = this.props.query.checkin.split("-");
      let checkOutArr = this.props.query.checkout.split("-");
      let checkInValue = cf.getDateWithFormat(
        new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
        this?.props?.dateFormat
      );
      let checkOutValue = cf.getDateWithFormat(
        new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
        this?.props?.dateFormat
      );
      let checkInOut =
        cf.getDateWithFormat(
          new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
          this?.props?.dateFormat
        ) +
        " - " +
        cf.getDateWithFormat(
          new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
          this?.props?.dateFormat
        );
      let roomsdetail = this.props.query.rooms.split("_");
      let totalRooms = roomsdetail.length;
      let totalAdult = 0;
      let totalChildren = 0;
      let roomListArr = [];
      let finalRoomListArr = []; //new
      roomsdetail.map((ele, index) => {
        let split = ele.split("-").filter((item) => item);
        totalAdult = Number(split[0].charAt(0)) + totalAdult;
        totalChildren = Number(split[1].charAt(0)) + totalChildren;
        roomListArr = [
          ...roomListArr,
          {
            id: index + 1,
            adults: Number(split[0].charAt(0)),
            children: Number(split[1].charAt(0)),
            adultAddCountDisable: false,
            adultMinusCountDisable: true,
            childrenAddCountDisable: false,
            childrenMinusCountDisable:
              Number(split[1].charAt(0)) == 1 ? false : true,
            childDetails: [],
          },
        ];

        split.map((element, id) => {
          if (id > 1)
            roomListArr[index].childDetails = [
              ...roomListArr[index].childDetails,
              { age: element, isOpen: false, isError: false },
            ];
        });
      });
      this.setState(
        {
          checkInOutValue: checkInOut,
          checkInValue: checkInValue,
          checkOutValue: checkOutValue,
          getDestinationId: this.props.query.destid,
          getSearchType: this.props.query.search_type,
          hotelName: this.props.AutoSuggestLabelName
            ? this.props.AutoSuggestLabelName
            : this?.props?.query?.region + ", " + this?.props?.query?.country,
          selectedRoomDetails: {
            rooms: totalRooms,
            guest: totalAdult + totalChildren,
          },
          roomList: roomListArr,
          nationallitySearch: this.props.query.nationality,
          selectedRatings: this.props.query.ratings
            ? this.props.query.ratings.split('_').map(rating => parseInt(rating)).filter(rating => rating >= 1 && rating <= 5)
            : [],
          guest_id: this.props.query.guestId,
        },
        // this.setState(prevState => ({
        //   ...prevState.selectedCheckBoxes,
        //   selectedCheckBoxes: {
        //       breakfast:[[this.props.query.bf]],
        //       room_type:[[this.props.query.rf]],
        //   }
        // })),
        () => {
          this.checkRoomDetails();
        }
      );
      const deepClone = JSON.parse(JSON.stringify(roomListArr));
      this.setState({
        finalRoomList: deepClone,
      });
    } else {
      if (regions) {
        this.renderInfo();
        // Detail Page Conditions
        if (this.props.isDetail) {
          let checkInArr = this.props.query.checkin.split("-");
          let checkOutArr = this.props.query.checkout.split("-");
          let checkInValue = cf.getDateWithFormat(
            new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
            this?.props?.dateFormat
          );
          let checkOutValue = cf.getDateWithFormat(
            new Date(
              checkOutArr[0],
              Number(checkOutArr[1]) - 1,
              checkOutArr[2]
            ),
            this?.props?.dateFormat
          );

          let checkInOut =
            cf.getDateWithFormat(
              new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
              this?.props?.dateFormat
            ) +
            " - " +
            cf.getDateWithFormat(
              new Date(
                checkOutArr[0],
                Number(checkOutArr[1]) - 1,
                checkOutArr[2]
              ),
              this?.props?.dateFormat
            );

          let roomsdetail = this.props.query.rooms.split("_");
          let totalRooms = roomsdetail.length;
          let totalAdult = 0;
          let totalChildren = 0;
          let roomListArr = [];
          let finalRoomListArr = []; //new
          roomsdetail.map((ele, index) => {
            let split = ele.split("-").filter((item) => item);
            totalAdult = Number(split[0].charAt(0)) + totalAdult;
            totalChildren = Number(split[1].charAt(0)) + totalChildren;
            roomListArr = [
              ...roomListArr,
              {
                id: index + 1,
                adults: Number(split[0].charAt(0)),
                children: Number(split[1].charAt(0)),
                adultAddCountDisable: false,
                adultMinusCountDisable: true,
                childrenAddCountDisable: false,
                childrenMinusCountDisable:
                  Number(split[1].charAt(0)) == 1 ? false : true,
                childDetails: [],
              },
            ];

            split.map((element, id) => {
              if (id > 1)
                roomListArr[index].childDetails = [
                  ...roomListArr[index].childDetails,
                  { age: element, isOpen: false, isError: false },
                ];
            });
          });

          this.setState({
            checkInOutValue: checkInOut,
            checkInValue: checkInValue,
            checkOutValue: checkOutValue,
            hotelName:
              this?.props?.query?.region + ", " + this?.props?.query?.country,
            getDestinationId: this?.props?.query?.destid,
            getSearchType: this?.props?.query?.search_type,
            selectedRoomDetails: {
              rooms: totalRooms,
              guest: totalAdult + totalChildren,
            },
            roomList: roomListArr,
            vid: this.props?.query?.vid,
            sid: this.state.getSearchType == 21 ? "" : this?.props?.query?.sid,
          });
        }
      }

      if (!this.props.isDetail && (this.props?.recentSearchData && this.props?.recentSearchData.length == 0)) {
        this.setState({
          checkInOutValue: this.getCheckInOutValue(
            this.state.checkInValue,
            this.state.checkOutValue
          ),
        });
      }
    }
    document.addEventListener("mousedown", this.handleClickOutside);
    // document.addEventListener("click", this.handleGlobalClick);

  }


  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener('mousedown', this.handleClickOutsideRatingDropdown);
    document.removeEventListener("click", this.handleRatingOutsideClick);
    document.removeEventListener('click', this.handleGlobalClick);
  }


  handleRatingOutsideClick = (event) => {
    if (this.ratingDivRef.current && !this.ratingDivRef.current.contains(event.target)) {
      this.setState({ showRatingDropdown: false });
    }
  };

  checkRoomDetails() {
    let { roomList } = this.state;
    roomList.map((ele, index) => {
      let totalAccomodation = ele.adults + ele.children;
      if (totalAccomodation <= 12) {
        if (totalAccomodation === 12) {
          roomList[index].adultAddCountDisable = true;
          roomList[index].childrenAddCountDisable = true;
        } else if (totalAccomodation < 12) {
          if (
            roomList[index].adultAddCountDisable === true &&
            roomList[index].childrenAddCountDisable === true
          ) {
            roomList[index].adultAddCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adults > 1) {
            roomList[index].adultMinusCountDisable = false;
          } else if (roomList[index].adults === 1) {
            roomList[index].adultMinusCountDisable = true;
            roomList[index].adultAddCountDisable = false;
          }
          if (roomList[index].children > 1) {
            roomList[index].childrenMinusCountDisable = false;
          } else if (roomList[index].children > 0) {
            roomList[index].childrenMinusCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
        }
      }
    });
    this.setState({ roomList: [...roomList] });
  }
  handleClickOutside = (e) => {
    if (
      this.dropdownWrapperRef &&
      !this.dropdownWrapperRef.contains(e.target)
    ) {
      if (this.props.expandHotelNameBoolean === true)
        this.props.expandHotelNameBooleanfunc(false);
      if (
        this.advanceSearchWrapper.current &&
        !this.advanceSearchWrapper.current.contains(event.target)
      ) {
        this.setState({ advSearch: false });
      }
      if (
        this.guestDetailWrapper.current &&
        !this.guestDetailWrapper.current.contains(event.target)
      ) {
        this.setState({ openTraveler: false });
      }
      if (
        this.state.expandCheckInOutDateBoolean === true ||
        this.state.openRoomDetailList === true
      ) {
        this.setState({
          expandCheckInOutDateBoolean: false,
          openRoomDetailList: false,
        });
      }
    }
  };

  setDropdownWrapperRef = (node) => {
    this.dropdownWrapperRef = node;
  };


  onClickDoneButton = () => {
    let totalGuest = 0;
    let count = 0;
    let Validation = true;
    let validation_arr = [];
    let roomList = this.state.roomList;

    while (count <= roomList.length) {
      if (
        !cf.isValueEmpty(roomList[count]) &&
        !cf.isValueEmpty(roomList[count].childDetails) &&
        roomList[count].childDetails.length > 0
      ) {

        roomList[count].childDetails.map((element, index) => {
          if (cf.isValueEmpty(element.age)) {
            roomList[count].childDetails[index].isError = true;
          }
        });

        validation_arr.push(
          roomList[count].childDetails.every(
            (item) => !cf.isValueEmpty(item.age)
          )
        );
        let checker = validation_arr.every(Boolean);
        Validation = checker;
      }
      count++;
    }

    this.setState({ roomList: [...roomList] }, () => {
      if (Validation === true) {
        this.state.roomList.length > 0 &&
          this.state.roomList.map((element) => {
            totalGuest = totalGuest + element.adults + element.children;
          });

        this.setState({
          selectedRoomDetails: {
            rooms: this.state.roomList.length,
            guest: totalGuest,
          },
        });
        const deepClone = JSON.parse(JSON.stringify(roomList));
        this.setState({
          finalRoomList: deepClone,
        });
        this.setState({ rooms: false }, () => {
          const mapDispatch = {
            hotelName: cf.isValueEmpty(this.state.hotelName),
            checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue),
            roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails)
          };
          if (!mapDispatch.hotelName && !mapDispatch.checkInOutDate && !mapDispatch.roomGuest) {
            this.onClickSearchHotel();
          }
        });
        document.querySelector("body").style.overflow = "auto";
        if (this.state.openRoomDetailList === true) {
          this.setState({ openRoomDetailList: false });
        }
      }
    });
  };

  removeRoomItem = (id) => {
    const filteredRoom = this.state.roomList.filter((item) => item.id !== id);
    this.setState({ roomList: [...filteredRoom] });
  };

  addAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        roomList[index].adults = roomList[index].adults + 1;
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].children = roomList[index].children + 1;
        roomList[index].childDetails = [
          ...roomList[index].childDetails,
          { age: "", isOpen: false, isError: false },
        ];
      }
    }
    let totalAccomodation = roomList[index].adults + roomList[index].children;

    if (this.props?.stays_villas) {
      if (totalAccomodation <= 20) {

        if (roomList[index].adults == 14) {
          roomList[index].adultAddCountDisable = true;
        }
        if (roomList[index].children == 6) {
          roomList[index].childrenAddCountDisable = true;
        }

        if (roomList[index].adults > 1) {
          roomList[index].adultMinusCountDisable = false;
        }
        if (roomList[index].children > 0) {
          roomList[index].childrenMinusCountDisable = false;
        }
        await this.setState({ roomList: [...roomList] });
      }
    } else {
      if (totalAccomodation <= 7) {
        if (totalAccomodation === 7) {
          roomList[index].adultAddCountDisable = true;
          roomList[index].childrenAddCountDisable = true;
        } else if (totalAccomodation < 7) {
          if (
            roomList[index].adultAddCountDisable === true &&
            roomList[index].childrenAddCountDisable === true
          ) {
            roomList[index].adultAddCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
        }
        if (roomList[index].adults > 1) {
          roomList[index].adultMinusCountDisable = false;
        }
        if (roomList[index].children > 0) {
          roomList[index].childrenMinusCountDisable = false;
        }
        await this.setState({ roomList: [...roomList] });
      }
    }

  };

  minusAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        if (roomList[index].adults >= 2) {
          roomList[index].adults = roomList[index].adults - 1;
          roomList[index].adultMinusCountDisable = roomList[index].adults === 1 ? true : false;
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
          if (!this.props?.stays_villas) {
            if (roomList[index].childrenAddCountDisable === true) {
              roomList[index].childrenAddCountDisable = false;
            }
          }

        } else if (roomList[index].adults === 1) {
          roomList[index].adultMinusCountDisable = true;
        }
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].childDetails.pop();
        if (roomList[index].children >= 1) {
          roomList[index].children = roomList[index].children - 1;
          roomList[index].childrenMinusCountDisable = false;
          if (roomList[index].childrenAddCountDisable === true) {
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
        } else if (roomList[index].children === 0) {
          roomList[index].childrenMinusCountDisable = true;
        }
      }
    }
    await this.setState({ roomList: [...roomList] });
  };

  isChildrenAge = (index, ind, type, age) => {
    let { roomList } = this.state;
    if (type === "isOpen") {
      roomList[index].childDetails[ind].isOpen =
        !roomList[index].childDetails[ind].isOpen;
    } else {
      roomList[index].childDetails[ind].age = age;
      roomList[index].childDetails[ind].isOpen = false;
      if (roomList[index].childDetails[ind].isError === true) {
        roomList[index].childDetails[ind].isError = false;
      }
    }
    this.setState({ roomList: [...roomList] });
  };

  onChangeCheckInOutValue = (value, type) => {

    if (type === "startDate") {
      this.setState({ checkInValue: value });

    } else if (type === "endDate") {
      let differenceInDays = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.checkInValue)
      );

      if (differenceInDays === 0) {
        this.setState({ checkOutValue: addDays(new Date(value), 1) }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(
                this?.state?.checkOutValue,
                this?.props?.dateFormat
              );
            this.setState({ checkInOutValue: checkInOut });
          }
        });
      } else {
        this.setState({ checkOutValue: value }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(value, this?.props?.dateFormat);
            this.setState({
              checkInOutValue: checkInOut,
              // openRoomDetailList: this.props.isMobile ? false : true
            });

          }
        });
      }
    }

  };

  onChangeSetHotelName = (value) => {
    let regexNum = alphanumericSpecialChars.test(value);

    if (regexNum) {
      this.setState(
        {
          hotelName: value.replace(leadingSpaces, ""), getDestinationId: "", isError: {
            ...this.state.isError,
            hotelName: false
          }
        },
        () => {
          if (this.state.isError.hotelName === true) {
            this.validateErrorMsg();
          }
          if (value.length > 2) {
            this.setState({ isSearchDest: true });
            this.props.getAutoSuggestValue(value);
          }
        }
      );
    }
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,

      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };
    this.setState({ isError: mapDispatch });
  };

  onClickSearchHotel = () => {

    if (
      this.state.hotelName &&
      this.props.getAutoSuggestList &&
      this.props.getAutoSuggestList?.length > 0
    ) {
      let LocalSearch = getStorage(this.state.search_key);
      let LocalSearchAll = JSON.parse(getStorage(this.state.search_key_all));
      const searchItem = JSON.parse(LocalSearch);
      let roomListArr = [];
      this.state.finalRoomList.map((res, id) => {
        roomListArr = [
          ...roomListArr,
          res.adults + "a-" + res.children + "c",
        ];
        res.childDetails.map((ele) => {
          roomListArr[id] = roomListArr[id].concat("-", ele.age);
        });
      });

      if (LocalSearch) {
        if (LocalSearchAll == null) {
          var searchData = getStorage(this.state.search_key);
          var searchDataArr = [JSON.parse(searchData)];

          let myObject = {
            destination_id: this.state.getDestinationId,
            search_type: this.state.getSearchType,
            search_text: this.state.hotelName,
            property_count: this.state.property_count,
            dest_type: {
              code: this.state.dest_type?.code || "",
              text: this.state.dest_type?.text || "",
            },
            checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
            checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
            selectedRoomDetails: this.state.selectedRoomDetails,
            roomList: roomListArr.join("_"),
            is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
            is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
          };

          if (searchItem.destination_id !== myObject.destination_id) {
            searchDataArr.unshift(myObject);
            var searchDataStrig = JSON.stringify(searchDataArr);
            setStorage(this.state.search_key, searchDataStrig);
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataArr)
            );
          }
        }

        if (LocalSearchAll) {
          var searchData = getStorage(this.state.search_key);
          var searchDataAll = JSON.parse(getStorage(this.state.search_key_all));
          var searchDataArr = [JSON.parse(searchData)];
          var indexArr = [];
          searchDataAll.forEach((x, i) => {
            indexArr.push(x.destination_id);
          });

          let myObject = {
            destination_id: this.state.getDestinationId,
            search_type: this.state.getSearchType,
            search_text: this.state.hotelName,
            property_count: this.state.property_count,
            dest_type: {
              code: this.state.dest_type?.code || "",
              text: this.state.dest_type?.text || "",
            },
            checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
            checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
            selectedRoomDetails: this.state.selectedRoomDetails,
            roomList: roomListArr.join("_"),
            is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
            is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
          };


          if (!indexArr.includes(myObject.destination_id)) {
            searchDataAll.unshift(myObject);
            var searchDataStrig = JSON.stringify(searchDataArr);
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataAll)
            );
          }

          if (searchDataAll.length > 4) {
            searchDataAll.pop();
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataAll)
            );
          }
        }
      } else {
        var searchData = [];
        let data = {
          destination_id: this.state.getDestinationId,
          search_type: this.state.getSearchType,
          search_text: this.state.hotelName,
          property_count: this.state.property_count,
          dest_type: {
            code: this.state.dest_type?.code || "",
            text: this.state.dest_type?.text || "",
          },
          checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
          checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
          selectedRoomDetails: this.state.selectedRoomDetails,
          roomList: roomListArr.join("_"),
          is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
          is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
        };
        // searchData.push(data); // add the object to the array
        searchData.unshift(data);
        var searchDartaStrig = JSON.stringify(searchData);
        setStorage(this.state.search_key, searchDartaStrig);
      }

      let data = {
        destination_id: this.state.getDestinationId,
        search_type: this.state.getSearchType,
        search_text: this.state.hotelName,
        property_count: this.state.property_count,
        dest_type: {
          code: this.state.dest_type?.code || "",
          text: this.state.dest_type?.text || "",
        },
        checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
        checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
        selectedRoomDetails: this.state.selectedRoomDetails,
        roomList: roomListArr.join("_"),
        is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
        is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
      };
      setStorage(this.state.search_key, JSON.stringify(data));
    }

    // main function =====>

    const mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,

      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };

    if (this.props.isOffline !== true) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
    }
    if (!this.props.isOffline) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
    }

    if (this.props.isDetail == true) {
      mapDispatch.hotelName = cf.isValueEmpty(regions) ? true : false;
    }
    mapDispatch.hotelName = this.state.getDestinationId ? false : true;
    this.setState({ isError: mapDispatch }, () => {
      let Validate = true;
      for (const [key, value] of Object.entries(this.state.isError)) {
        if (value === true) {
          Validate = false;
          break;
        }
      }

      if (Validate === true) {
        let hotelNameArry = this.state.hotelName.split(",");
        let roomListArr = [];
        this.state.finalRoomList.map((res, id) => {
          roomListArr = [
            ...roomListArr,
            res.adults + "a-" + res.children + "c",
          ];
          res.childDetails.map((ele) => {
            roomListArr[id] = roomListArr[id].concat("-", ele.age);
          });
        });
        //IF CHECKOUT DATE IS EMPTY
        if (!this.state.checkOutValue) {
          this.state.checkOutValue = cf.getDateWithFormat(
            addDays(new Date(this.state.checkInValue), 2),
            this?.props?.dateFormat
          );
        }
        let urlQuery = {
          region: hotelNameArry[0]?.trim(),
          country:
            this.props.isSRP === true
              ? hotelNameArry[1]?.trim()
              : hotelNameArry[hotelNameArry.length - 1]?.trim(),
          checkin: format(new Date(this.state.checkInValue), "yyyy-MM-dd"),
          checkout: format(new Date(this.state.checkOutValue), "yyyy-MM-dd"),
          rooms: this.state.isRecentSearch ? this.state.roomsData : roomListArr.join("_"),
          type: "location",
          roomtype: "single",
          page: 1,
          orderby: "desc",
          mop: "accrual",
          destid: this.state.getDestinationId,
          search_type: this.state.getSearchType,
          // ratings: "",
          ratings: this.state.selectedRatings.length > 0 ? this.state.selectedRatings.join('_') : "",
          is_breakfast: this.props?.state?.showBreakfast
            ? this.props?.state?.showBreakfast
            : null,
          is_free_cancellation: this.props.state?.showFreeCancellation
            ? this.props?.state.showFreeCancellation
            : null,
          is_stays_villas: this.props?.stays_villas
            ? this.props.stays_villas
            : null,
          nationality: this.state.nationallitySearch,
          guestId: this.state.guest_id,
          is_web_app: false,
          vid:
            this.state.getSearchType == 21
              ? this.state.getDestinationId
              : this?.props?.query?.vid,
          sid: this.state.getSearchType == 21 ? "" : this?.props?.query?.sid,
        };
        this.setState({
          btnClicked: true,
        });

        if (this.props.isDetail === true || this.state.getSearchType == 21) {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          localStorage.setItem("hotel_srp", "");
          window.location = "/hotel/details?" + queryString;
        } else {

          if (
            this.state.hotelName &&
            this?.props?.userProfile &&
            this?.props?.userProfile?.status
          ) {
            if (true) {
              let data = {
                destination_id: this.state.getDestinationId || "",
                search_type: this.state.getSearchType || "",
                search_text: this.state.hotelName || "",
                property_count: this.state.property_count || "",
                dest_type: {
                  code: this.state.dest_type?.code || "",
                  text: this.state.dest_type?.text || "",
                },
              };

              getRecentSearchHotel(data).then((res) => {
              });
            }
          }
          if (this.props.isSRP) {
            this.props.setOpenMobWid();
          }
          localStorage.setItem("hotel_srp", JSON.stringify(urlQuery));
          cf.redirectTo("/hotel/search", urlQuery);
        }
      }
    });
  };

  onClickSetHotelName = (element) => {

    this.setState({
      hotelName: element.search_text,
      getDestinationId: element.destination_id,
      getSearchType: element.search_type ? element.search_type : 6,
      property_count: element?.property_count,
      dest_type: {
        code: element?.dest_type?.code,
        text: element?.dest_type?.text,
      },
      expandCheckInOutDateBoolean: this.props.isMobile ? false : true,
      isError: {
        ...this.state.isError,
        hotelName: false
      }
    }, () => {
      if (this.props.isMobile) {
        setTimeout(() => {
          this.setState({ expandCheckInOutDateBoolean: true })
        }, 500);
      }
    });
  };

  getCheckInOutValue = (checkIn, checkOut) => {
    let checkInArr = checkIn.split("/");
    let checkOutArr = checkOut.split("/");
    return checkIn + " - " + checkOut;
  };

  onClickVisibilityStatus = (type, value) => {

    if (!this.props?.isMobile && type != "hotel" && type != "calendar") {
      this.setScrollDown.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }


    switch (type) {
      case "hotel":
        this.props.expandHotelNameBooleanfunc(value);
        if (
          this.state.expandCheckInOutDateBoolean === true ||
          this.state.openRoomDetailList === true
        ) {
          this.setState({
            expandCheckInOutDateBoolean: false,
            openRoomDetailList: false,
          });
        }
        break;
      case "calendar":
        this.setState({ expandCheckInOutDateBoolean: value }, () => {
          if (
            this.props.expandHotelNameBoolean === true ||
            this.state.openRoomDetailList === true
          ) {
            this.setState({ openRoomDetailList: false });
            this.props.expandHotelNameBooleanfunc(false);
          }
          if (!this.state.expandCheckInOutDateBoolean && this.props.isMobile) {
            setTimeout(() => {
              this.setState({ rooms: true });
            }, 500);
          }
        });
        break;
      case "rooms":
        this.setState({ isRecentSearch: false });
        if (this.state.openRoomDetailList === false) {
          this.setState({ openRoomDetailList: true }, () => {
            if (
              this.props.expandHotelNameBoolean === true ||
              this.state.expandCheckInOutDateBoolean === true
            ) {
              this.setState({ expandCheckInOutDateBoolean: false });
              this.props.expandHotelNameBooleanfunc(false);
            }
          });
        } else {
          this.onClickDoneButton();
        }

        break;
      default:
        break;
    }
  };



  onClickHotelInput = () => {

    this.setState({ recentSearchClicked: false });
    this.props.onClickRecentSearch(false);
    this.props.getAutoSuggestValue("");
  };

  renderInfo = () => {
    this?.props?.getAutoSuggestValue(regions);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps?.state?.recentSearchClicked !== this.props?.state?.recentSearchClicked) {
      this.setState({ recentSearchClicked: true });
    }
    if (
      regions != null &&
      regions != "" &&
      regions != undefined &&
      !this.props.isSRP
    ) {
      if (
        prevProps?.getAutoSuggestList?.length <
        this?.props?.getAutoSuggestList?.length
      ) {
        prevProps.getAutoSuggestList = this.props.getAutoSuggestList;
        this.setState(
          {
            hotelName: prevProps.getAutoSuggestList[0].search_text,
            getDestinationId: prevProps.getAutoSuggestList[0].destination_id,
            getSearchType: prevProps.getAutoSuggestList[0].search_type,
          },
          () => {
            this.props.expandHotelNameBooleanfunc(false);
          }
        );
      }
    }


    if (this.state.recentSearchClicked && this.props.state?.hotelName
      && this.props.state?.hotelName !== this.state.hotelName
    ) {
      this.setState({
        hotelName: this.props.state.hotelName,
        getDestinationId: this.props.state.getDestinationId,
        getSearchType: this.props.state.getSearchType,
        property_count: this.props.state.property_count,
        dest_type: {
          code: this.props.state.dest_type?.code,
          text: this.props.state.dest_type?.text,
        },
        checkInOutValue: cf.getDateWithFormat(new Date(this.props.state?.checkin), this?.props?.dateFormat) + " - " +
          cf.getDateWithFormat(addDays(new Date(this.props.state?.checkin),
            this.props.getDefaultDays ? this.props.getDefaultDays : 2
          ), this?.props?.dateFormat),
        checkInValue: cf.getDateWithFormat(new Date(this.props.state?.checkin), this?.props?.dateFormat),
        checkOutValue: cf.getDateWithFormat(
          addDays(
            new Date(this.props.state?.checkin),
            this.props.getDefaultDays ? this.props.getDefaultDays : 2
          ),
          this?.props?.dateFormat
        ),
        selectedRoomDetails: this.props.state?.selectedRoomDetails,
        roomsData: this.props.state?.roomList,
        isRecentSearch: true,
      });
    }


  }

  onInputFocus = (fieldName) => {
    if (fieldName == "autocomplete") {
      this.onClickVisibilityStatus("hotel", true);
    }
    if (fieldName == "calendar") {
      this.onClickVisibilityStatus("calendar", true);
      this.setState({ expandCheckInOutDateBoolean: true });
    }
    if (fieldName == "rooms") {
      this.onClickVisibilityStatus("rooms");
      this.setState({
        openRoomDetailList: true,
      });
    }
    if (fieldName == "search") {
      this.setState({ openRoomDetailList: false });
    }
  };

  highlightData(id, parentElement) {
    let innerContent = document.getElementById(parentElement).children;
    for (let i = 0; i < innerContent.length; i++) {
      let selectedElement = innerContent[i];
      selectedElement.style.backgroundColor = i == id ? "#ccc" : "#fff";
    }
    innerContent[id].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  onKeyDownArrow = (event, parentClassId, moduleType) => {
    const autoSuggestList = !cf.isValueEmpty(this.props.getAutoSuggestList)
      ? this.props.getAutoSuggestList
      : [];
    const recentSearchLogedin = this.props.getRecentSearchList;
    let recentSearchList = null;
    let mainArray = [];

    if (true) {
      let LocalSearch = getStorage(this.state.search_key);
      let LocalSearchAll = getStorage(this.state.search_key_all);

      if (LocalSearchAll != null) {
        recentSearchList = JSON.parse(LocalSearchAll);
      }
      if (LocalSearch != null && LocalSearchAll == null) {
        recentSearchList = [JSON.parse(LocalSearch)];
      }
    }

    if (this.props?.userProfile && this.props?.userProfile?.status) {
      if (recentSearchLogedin.length > 0 && autoSuggestList.length > 0) {
        mainArray = autoSuggestList.concat(recentSearchLogedin);
      } else if (
        recentSearchLogedin.length == 0 &&
        autoSuggestList.length > 0
      ) {
        mainArray = autoSuggestList;
      } else if (
        recentSearchLogedin.length > 0 &&
        autoSuggestList.length == 0
      ) {
        mainArray = recentSearchLogedin;
      } else {
        mainArray = [];
      }
    } else {
      if (recentSearchList?.length > 0 && autoSuggestList?.length > 0) {
        mainArray = autoSuggestList.concat(recentSearchList);
      } else if (recentSearchList == null && autoSuggestList?.length > 0) {
        mainArray = autoSuggestList;
      } else if (recentSearchList?.length > 0 && autoSuggestList?.length == 0) {
        mainArray = recentSearchList;
      } else {
        mainArray = [];
      }
    }

    if (mainArray.length > 0) {
      const ids = mainArray.map(({ destination_id }) => destination_id);
      mainArray = mainArray.filter(
        ({ destination_id }, index) => !ids.includes(destination_id, index + 1)
      );
    }

    this.setState({ isKeyDown: true });

    switch (event.which) {
      case 38: // up
        this.setState({ isKeyDown: true });
        if (mainArray.length > 0) {
          indexDropdown--;
          if (indexDropdown < 0) {
            indexDropdown = 0;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_text}`
              : "";
          destination_id =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].destination_id}`
              : "";
          search_type =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_type
                ? mainArray[indexDropdown].search_type
                : 1
              }`
              : "";
        }

        break;
      case 40:
        this.setState({ isKeyDown: true });
        if (
          mainArray.length > 0 &&
          this.state.isKeyDown &&
          !this.state.isSearchDest
        ) {
          indexDropdown++;
          if (indexDropdown >= mainArray.length - 1) {
            indexDropdown = mainArray.length - 1;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_text}`
              : "";
          destination_id =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].destination_id}`
              : "";
          search_type =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_type
                ? mainArray[indexDropdown].search_type
                : 1
              }`
              : "";
        }
        if (this.state.isSearchDest) {
          indexDropdown++;
          if (indexDropdown > this.props.getAutoSuggestList.length - 1) {
            indexDropdown = 0;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].search_text}`
              : "";
          destination_id =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].destination_id}`
              : "";
          search_type =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].search_type
                ? this.props.getAutoSuggestList[indexDropdown].search_type
                : 1
              }`
              : "";
        }

        break;

      case 13: //enter
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
            isKeyDown: false,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;
        break;
      case 9: //tab
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
            isKeyDown: false,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;

        break;
      default:
    }
  };

  focusOutDone = () => {

    this.setState({
      openRoomDetailList: this.state.openRoomDetailList,
    });

  };



  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };

  onClickAdvSearch = () => {
    if (!this.state.advSearch) {
      this.setState({ advSearch: true });
    } else {
      this.setState({ advSearch: false });
    }
  };

  onClickNationality = () => {
    if (!this.state.nationallitySearch) {
      this.setState({ nationallitySearch: true });
    } else {
      this.setState({ nationallitySearch: false });
    }
  };

  onTickAdvSearch = () => {
    cf.redirectTo("/hotel/search", urlQuery);
  };

  handleStarCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleCheckboxSelection = (event, index) => {
    let updatedSelections = new Array(index + 1).fill(false);
    updatedSelections[index] = event.target.checked;

    this.setState((prev) => ({
      selectedCheckBoxes: {
        ...prev.selectedCheckBoxes,
        [event.target.name]: updatedSelections,
      },
    }));
  };

  adGuestId = (id) => {
    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        this.validateErrorMsg();
      }
      this.setState({ guest_id: id });
    });
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };

  handleOnClick = async (suggestion, index) => {
    this.setState({ selectedDestination: index });
    await this.onClickSetHotelName(suggestion);
    await this.onClickSearchHotel();
    return suggestion;
  };

  handlePaxComp = () => {
    this.setState({
      roomList: [
        ...this.state.roomList,
        {
          id: this.state.roomList.length + 1,
          adults: 1,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: true,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
    });
  };


  clearDate = () => {
    let checkInOut = cf.getDateWithFormat(new Date(), this?.props?.dateFormat) + " - " +
      cf.getDateWithFormat(addDays(new Date(),
        this.props.getDefaultDays ? this.props.getDefaultDays : 2
      ), this?.props?.dateFormat);


    this.setState({
      checkInOutValue: checkInOut,
      checkInValue: new Date(),
      checkOutValue: addDays(new Date(), this.props.getDefaultDays ? this.props.getDefaultDays : 2),
    })
  };






  handleGlobalClick = (event) => {
    const ratingParent = event.target.closest(`.${this.props.styles?.rating_parent}`);
    if (!ratingParent && this.state.showRatingDropdown) {
      this.setState({ showRatingDropdown: false });
    }
  };

  handleRatingDivClick = () => {
    this.setState(prevState => ({
      showRatingDropdown: !prevState.showRatingDropdown
    }));
  };

  onClickSetRating = (rating) => {
    const { selectedRatings } = this.state;
    let updatedRatings;

    if (selectedRatings.includes(rating)) {
      // Remove rating if already selected
      updatedRatings = selectedRatings.filter(r => r !== rating);
    } else {
      // Add rating if not selected
      updatedRatings = [...selectedRatings, rating];
    }

    this.setState({ selectedRatings: updatedRatings });
  };

  render() {
    const currentPath = window.location.pathname;



    const popularDestination = this.props?.PopularDestination ? true : false;

    return (
      <div
        ref={this.setScrollDown}
        className={`${this.props.isMobile ? this.props.styles?.hotel_mobileContainer : ""
          } ${this.props.styles?.hotel_widget_container}`}
      >
        <div className={this.props.styles?.hotel_search_wid_container}>
          <div className={this.props.styles?.hotel_search_wid_main}>
            <div
              className={`${this.props.styles?.hotel_search_details_container
                } ${this.props.styles?.home_bgcolor
                }`}
            >
              <div className={this.props.styles?.hotel_search_details_main}>
                <div
                  className={this.props.styles?.hotel_search_details_row}
                  ref={this.setDropdownWrapperRef}
                >
                  <div
                    id="hotelList"
                    className={`${this.props.styles?.hotel_search_column} ${this.props.styles?.hotel_search_name
                      } `}
                    tabIndex="1"
                  >
                    {!this.props.isMobile && (

                      <HotelAutoComplete
                        tabIndex={1}
                        isDisable={this.props.isDisable === true}
                        label={""}
                        styles={this.props.styles}
                        value={this.state.hotelName}
                        onKeyDownArrow={(event) => {
                          this.onKeyDownArrow(
                            event,
                            "hotelDataArray",
                            "hotel"
                          );
                        }}
                        placholder={
                          this.props.isOffline
                            ? "Select Country"
                            : "Where are you going?"
                        }
                        onInputFocus={() => {
                          this.onInputFocus("autocomplete");
                        }}
                        onClickHotelInput={() => this.onClickHotelInput()}
                        onClickHotelName={(value) =>
                          this.onClickSetHotelName(value)
                        }
                        onChangeHotelName={(value) =>
                          this.onChangeSetHotelName(value)
                        }
                        isAutoCompleteExpand={(value) =>
                          this.onClickVisibilityStatus("hotel", value)
                        }
                        autoCompleteData={
                          !cf.isValueEmpty(this.props.getAutoSuggestList)
                            ? this.props.getAutoSuggestList
                            : []
                        }
                        expandAutoCompleteBool={
                          !cf.isValueEmpty(this.props.expandHotelNameBoolean)
                            ? this.props.expandHotelNameBoolean
                            : false
                        }
                        leftIcon={
                          <span>

                            <img src="/images/Hotel_Location.svg" alt="search" />
                          </span>
                        }
                        errorMessage={
                          this.state.isError.hotelName
                            ? ""
                            : "Enter Destination"
                        }
                        isError={this.state.isError.hotelName}
                        isSrp={this.props.isSRP}
                        onStateUpdate={() => this.onClickSetHotelName(this.props?.state)}
                      />
                    )}
                    {this.props.isMobile && (
                      <div
                        className={this.props.styles?.widget_mainBox}
                        onClick={() => {
                          document.querySelector("body").style.overflow =
                            "hidden";
                          this.setState({
                            destination: true,
                          });
                        }}
                      >

                        <div
                          className={this.props.styles?.widgMob_inp}
                          onClick={() => {
                            document.querySelector("body").style.overflow =
                              "hidden";
                            this.setState({
                              destination: true,
                            });
                          }}
                        >

                          <img src="/images/Hotel_Location.svg" alt="search" />
                          <input
                            value={this.state.hotelName}
                            type="text"
                            placeholder="City, Property Name Or Location"
                            tabIndex="1"
                          />
                        </div>

                        {this.state.destination == false && (
                          <div className={this.props.styles?.error_message}>
                            <span>
                              {this.state.hotelName == "" &&
                                this.state.isError.hotelName
                                ? "Enter destination"
                                : ""}
                              {this.state.hotelName != "" &&
                                this.props.getAutoSuggestList.length == 0
                                ? "Enter valid destination"
                                : ""}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {!this.props.isMobile && (
                    <div
                      ref={this.setScrollCal}
                      onClick={() => {
                        this.onClickVisibilityStatus("calendar", true);
                      }}
                      className={`${this.props.styles.hotel_search_column} ${this.props.isSRP
                        ? this.props.styles.hotel_Srp_search_date
                        : this.props.styles.hotel_search_date
                        }`}
                    >

                      <DesktopCalender
                        // tabIndex={2}
                        label=""
                        styles={this.props.styles}
                        value={
                          !cf.isValueEmpty(this.state.checkInOutValue)
                            ? this.state.checkInOutValue
                            : ""
                        }
                        placholder="Select Date"
                        onChangeDate={(type, value) => {
                          this.onChangeCheckInOutValue(type, value);
                        }}
                        onClearDate={(type, value) => {
                          this.clearDate(type, value);
                        }}
                        onInputFocus={() => {
                          this.onInputFocus("calendar");
                        }}
                        iconImage={
                          <img src="/images/calendar.svg" alt="cal_icon" />
                        }
                        startDate={
                          !cf.isValueEmpty(this.state.checkInValue)
                            ? this.state.checkInValue
                            : ""
                        }
                        endDate={
                          !cf.isValueEmpty(this.state.checkOutValue)
                            ? this.state.checkOutValue
                            : ""
                        }
                        startDateLimit={
                          !cf.isValueEmpty(this.state.dateLimit)
                            ? this.state.dateLimit
                            : ""
                        }
                        dateFormat={this?.props?.dateFormat}
                        changeVisibility={(bool) =>
                          this.onClickVisibilityStatus("calendar", bool)
                        }
                        onEndDateSelected={() => {
                          this.setState({ openRoomDetailList: true });
                        }}
                        isVisible={this.state.expandCheckInOutDateBoolean}
                        type={"double"}
                        doubleSelection={true}
                      />

                    </div>
                  )}
                  {this.props.isMobile && (
                    <div
                      className={`${this.props.styles?.widget_mainBox} ${this.props.styles?.mobile_widget_container_new}`}
                      onClick={() => {
                        this.setState({
                        });
                      }}
                    >
                      <div className={this.props.styles?.widgMob_Wrapflx}>
                        <div className={this.props.styles?.widgMob_sec}>

                          {/* <div className={this.props.styles?.calender_overlay}>
                          <MobileCalender
                            styles={this.props.styles}
                            value={
                              !commonFunction.isValueEmpty(
                                this.state.checkInOutValue
                              )
                                ? this.state.checkInOutValue
                                : ""
                            }
                            placholder="Select the date"
                            onChangeDate={(type, value) => {
                              this.onChangeCheckInOutValue(type, value);
                            }}
                            iconImage="/images/calendar.svg"
                            startDate={
                              !commonFunction.isValueEmpty(
                                this.state.checkInValue
                              )
                                ? this.state.checkInValue
                                : ""
                            }
                            endDate={
                              !commonFunction.isValueEmpty(
                                this.state.checkOutValue
                              )
                                ? this.state.checkOutValue
                                : ""
                            }
                            startDateLimit={
                              !commonFunction.isValueEmpty(this.state.dateLimit)
                                ? this.state.dateLimit
                                : ""
                            }
                            dateFormat={"DD-MMM-YYYY"}
                            changeVisibility={(bool) =>
                              this.onClickVisibilityStatus("calendar", bool)
                            }
                            isVisible={this.state.expandCheckInOutDateBoolean}
                            type={"double"}
                            doubleSelection={true}
                            totalMonths={12}
                            serviceType="hotel"
                            isMobile={true}
                            isCheckIn={true}
                            label="Check In"
                            onClearDate={(type, value) => {
                              this.clearDate(type, value);
                            }}
                          />
                          </div> */}
                          <div className={this.props.styles?.calender_overlay}>
                            <MobileCalender
                              styles={this.props.styles}

                              value={
                                !commonFunction.isValueEmpty(this.state.checkInOutValue)
                                  ? this.state.checkInOutValue
                                  : ""
                              }

                              placholder="Select the date"

                              onChangeDate={(type, value) => {
                                this.onChangeCheckInOutValue(type, value);
                              }}

                              iconImage="/images/calendar.svg"

                              startDate={this.state.checkInValue || ""}
                              endDate={this.state.checkOutValue || ""}
                              startDateLimit={this.state.dateLimit || ""}

                              dateFormat="DD-MMM-YYYY"

                              /* 🔥 IMPORTANT */
                              isVisible={this.state.expandCheckInOutDateBoolean}
                              changeVisibility={(bool) =>
                                this.onClickVisibilityStatus("calendar", bool)
                              }

                              doubleSelection={true}
                              type="double"
                              totalMonths={12}
                              serviceType="hotel"
                              isMobile={true}

                              onClearDate={(type, value) => {
                                this.clearDate(type, value);
                              }}

                              /* modal css */
                              PopupMobCss={this.props.PopupMobCss}
                            />
                          </div>

                        </div>

                      </div>
                    </div>
                  )}


                  {this.props.isMobile && (
                    <div
                      className={this.props.styles?.widget_mainBox}
                      onClick={() => {
                        this.setState({
                          rooms: true,
                        });
                        document.querySelector("body").style.overflow =
                          "hidden";
                      }}
                    >
                      <div className={this.props.styles?.widgMob_Wrapflx}>
                        <div className={this.props.styles?.widgMob_sec}>

                          <div className={this.props.styles?.widgMob_dateInp}>

                            <img src="/images/HotelBed.svg" alt="guest_icon" />
                            <span>
                              {this.state.selectedRoomDetails.rooms > 1
                                ? `${this.state.selectedRoomDetails.rooms} Rooms`
                                : `${this.state.selectedRoomDetails.rooms} Room`}
                              , {this.state.selectedRoomDetails.guest}{" "}
                              {this.state.selectedRoomDetails.guest > 1
                                ? " Guests"
                                : " Guest"}
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  )}
                  {this.props.isMobile && (
                    <div className={this.props.styles?.hotel_search_btn} style={{ 'opacity': cf.isValueEmpty(this.state.hotelName) ? '0.5' : 'unset' }}>
                      <Button
                        className={
                          this.state?.btnClicked
                            ? `${this.props.styles?.hotel_search_widget_btn} loading`
                            : this.props.styles?.hotel_search_widget_btn
                        }
                        name={"Search"}
                        isHandleOnClick={this.onClickSearchHotel}
                        disabled={cf.isValueEmpty(this.state.hotelName)}
                      >
                        {"Search"}
                      </Button>
                    </div>
                  )}


                  {!this.props.isMobile &&

                    <PaxComp
                      theme="theme12"
                      styles={this.props.paxCompStyle}
                      onClickVisibilityStatus={this.onClickVisibilityStatus}
                      state={this.state}
                      onInputFocus={this.onInputFocus}
                      removeRoomItem={this.removeRoomItem}
                      minusAccomodationCount={this.minusAccomodationCount}
                      addAccomodationCount={this.addAccomodationCount}
                      isChildrenAge={this.isChildrenAge}
                      setState={this.setState}
                      onClickDoneButton={this.onClickDoneButton}
                      focusOutDone={this.focusOutDone}
                      handlePaxComp={this.handlePaxComp}
                      label={""}
                      adultLabel={""}
                      childLabel={"(Age 11 years & below)"}
                      totalRooms={this.props?.stays_villas ? 6 : 4}
                      isSRP={this.props.isSRP}
                    />}

                  {!this.props.isMobile && (
                    <div className={this.props.styles?.hotel_search_btn} style={{ 'opacity': cf.isValueEmpty(this.state.hotelName) ? '0.5' : '1' }}>
                      <Button
                        className={
                          this.state?.btnClicked
                            ? `${this.props.styles?.hotel_search_widget_btn} loading`
                            : this.props.styles?.hotel_search_widget_btn
                        }
                        name={
                          "Hotels Search"
                        }
                        isHandleOnClick={this.onClickSearchHotel}
                        disabled={cf.isValueEmpty(this.state.hotelName)}
                      >
                      <img src='/images/WhiteSearch.svg' />
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>


            {popularDestination && !this.props.isMobile && this.props.getAutoSuggestList && (
              <div className={this.props.styles?.popular_destination}>
                <div className={this.props.styles?.populardest_title}>
                  Popular Destination
                </div>
                <div className={this.props.styles?.destination_container}>
                  {this.props.homeData.map((sugesstion, index) => {
                    let popDestination = sugesstion.search_text.split(",");
                    return (
                      <div
                        key={index}
                        className={
                          index === this.state.selectedDestination
                            ? this.props.styles?.destination_active
                            : this.props.styles?.destination_item
                        }
                        onClick={() => this.handleOnClick(sugesstion, index)}
                      >
                        <div className={this.props.styles?.destination_name}>
                          {popDestination[0]}
                        </div>
                        <div className={this.props.styles?.property_count}>
                          {sugesstion.property_count} Properties
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* For Destination Popup ===> */}

        <div className={this.props.styles?.hotel_destination_popup}>
          <MobPopupComponent
            isPopup={this.state.destination}
            modalCss={this.props?.PopupMobCss}

            /* enable outside click close */
            outSideClickBool={true}
            onOutSideClick={(value) => {
              this.setState({ destination: value });
              document.body.style.overflow = "auto";
            }}

            showCrossButton={false}
            onClosePopup={() => {
              this.setState({ destination: false });
              document.body.style.overflow = "auto";
            }}

            /* back button not required */
            showBackButton={false}
          >
            <div>
              <HotelAutoComplete
                isDisable={this.props.isDisable === true}
                label="City, Property Name Or Location"
                styles={this.props.styles}
                value={this.state.hotelName}
                userProfile={this.props.userProfile}

                getrecentSearchList={
                  this?.props?.userProfile?.status
                    ? !cf.isValueEmpty(this.props.getRecentSearchList)
                      ? this.props.getRecentSearchList
                      : []
                    : !cf.isValueEmpty(this.state.getrecentSearchListLocal)
                      ? this.state.getrecentSearchListLocal
                      : this.state.getrecentSearchListLocal
                }

                onKeyDownArrow={(event) => {
                  this.onKeyDownArrow(event, "hotelDataArray", "hotel");
                }}

                placholder="Enter a city, hotel, airport, address or landmark"

                onInputFocus={() => {
                  this.onInputFocus("autocomplete");
                }}

                onClickHotelInput={() => this.onClickHotelInput()}

                onClickHotelName={(value) => {
                  this.onClickSetHotelName(value);
                  this.setState({ destination: false });
                  document.body.style.overflow = "auto";
                }}

                onChangeHotelName={(value) => this.onChangeSetHotelName(value)}

                isAutoCompleteExpand={(value) =>
                  this.onClickVisibilityStatus("hotel", value)
                }

                autoCompleteData={
                  !cf.isValueEmpty(this.props.getAutoSuggestList)
                    ? this.props.getAutoSuggestList
                    : []
                }

                expandAutoCompleteBool={
                  !cf.isValueEmpty(this.props.expandHotelNameBoolean)
                    ? this.props.expandHotelNameBoolean
                    : false
                }

                disabled={this.props.isDisable === true}
                isMobile={true}
              />
            </div>
          </MobPopupComponent>
        </div>



        {/* For rooms & guest Popup ===> */}
        <div className={this.props.styles?.hotel_destination_popup}>
          <MobPopupComponent
            theme="theme12"
            isPopup={this.state.rooms}
            modalCss={this.props?.PopupMobCss}
            outSideClickBool={true}
            onOutSideClick={() => {
              this.setState({ rooms: false });
              document.querySelector("body").style.overflow = "auto";
            }}
            showCrossButton={false}
            onClosePopup={() => {
              this.setState({ rooms: false });
              document.body.style.overflow = "auto";
            }}
            showBackButton={false}

          >
            <div className={this.props.styles?.paxMobile_container}>
              <PaxComp
                theme="theme12"
                styles={this.props.paxCompStyle}
                onClickVisibilityStatus={this.onClickVisibilityStatus}
                state={this.state}
                onInputFocus={this.onInputFocus}
                removeRoomItem={this.removeRoomItem}
                minusAccomodationCount={this.minusAccomodationCount}
                addAccomodationCount={this.addAccomodationCount}
                isChildrenAge={this.isChildrenAge}
                setState={this.setState}
                onClickDoneButton={this.onClickDoneButton}
                focusOutDone={this.focusOutDone}
                handlePaxComp={this.handlePaxComp}
                isMobile={true}
                label={""}
                adultLabel={""}
                childLabel={"(Age 11 years & below)"}
                totalRooms={this.props?.stays_villas ? 6 : 4}
              />
            </div>
          </MobPopupComponent>
        </div>

        {!this.props.isMobile && currentPath === "/hotels" && (
          <div className={this.props.styles?.hotel_search_widget_footer}>
            <div>
              <label className={this.props.styles?.hotel_search_widget_footer_checkbox_label}>
                <input type="checkbox" id="free_cancellation"
                  onChange={() => this.props.setStateNew({ showFreeCancellation: !this.props.state.showFreeCancellation })}
                  className={this.props.styles.checkbox_input} />
                Free cancellation
              </label>
            </div>

            <div>
              <label className={this.props.styles?.hotel_search_widget_footer_checkbox_label}>
                <input type="checkbox" id="free_breakfast"
                  // checked= {this.props.setState({showBreakfast : !this.props.state.showBreakfast})}
                  onChange={() => this.props.setStateNew({ showBreakfast: !this.props.state.showBreakfast })}
                  className={this.props.styles.checkbox_input} />
                Free breakfast
              </label>
            </div>

            <div className={this.props.styles?.rating_parent}>
               <div
              className={this.props.styles?.rating_dropdown_trigger}
              onClick={this.handleRatingDivClick}
              ref={this.ratingDivRef}
               >
              <div className={this.props.styles?.rating_text_wrapper}>
                <div className={this.props.styles?.rating_star_text_parent}>
                  <img src="images/darkStar.svg" alt="Star Icon" />
                  <span>Star Rating</span>
                </div>

                {this.state.selectedRatings.length > 0 && (
                  <span className={this.props.styles?.rating_count}>
                    ({this.state.selectedRatings.sort().join(', ')} Star
                    {this.state.selectedRatings.length > 1 ? 's' : ''})
                  </span>
                )}
              </div>

                <img
                  src="images/downarrow_golden.svg"
                  alt="Star Rating"
                  className={`${this.props.styles?.rating_dropdown_arrow} ${
                    this.state.showRatingDropdown ? this.props.styles?.rotate : ''
                  }`}
                />
            </div>

              {this.state.showRatingDropdown && (
                <div className={this.props.styles?.rating_dropdown_content}>
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <div
                      key={rating}
                      className={this.props.styles?.rating_option}
                      onClick={() => this.onClickSetRating(rating)}
                    >
                      <input
                        type="checkbox"
                        checked={this.state.selectedRatings.includes(rating)}
                        readOnly
                        className={this.props.styles?.rating_checkbox}
                      />

                      <span className={this.props.styles?.rating_text}>
                        {rating} Star{rating > 1 ? 's' : ''}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>
        )}


      </div>
    );
  }
}
